import React from 'react'

const DividingBar = () => {
   return (
      <>
         <div>
            <div className="container section center white-text">
               <h5>
               <strong className="black-text text-darken-2"></strong>
               </h5>
            </div>
         </div>
      </>
   );
}

export default DividingBar